import Input from "../../components/Input/Input";
import PictureDrop from "../../components/Input/PictureDrop";

const ClientForm = ({formik}) => {
    return (
        <form id="client-form" onSubmit={formik.handleSubmit}>
            <Input
                name="name"
                label="Company Name"
                formik={formik}
                required
            />
            <Input
                name="email"
                label="Email"
                formik={formik}
                required
            />
            <Input
                name="color"
                label="Color"
                type="color"
                formik={formik}
                required
            />
            <PictureDrop
                name="logo"
                label="Profile Picture"
                formik={formik}
            />

        </form>
    );
};

export default ClientForm;